module.exports = __webpack_public_path__ + "media/images/payments/laser-dark-61df808c835661d586f77238aff050a6.svg";